<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">{{$t('ResetPassword')}}</h4>
                                    <p>{{$t('RESET_PASSWORD_MESSAGE')}}</p>
                                </div>
                                <vs-input
                                    v-validate="'required|min:3'"
                                    data-vv-validate-on="blur"
                                    name="id"
                                    :label-placeholder="$t('ID')"
                                    v-model="id"
                                    class="w-full"/>
                                <span class="text-danger text-sm">{{ errors.first('id') }}</span>
                                <vs-input
                                    v-validate="'required|email'"
                                    data-vv-validate-on="blur"
                                    name="email"
                                    :label-placeholder="$t('EMAIL')"
                                    v-model="email"
                                    class="w-full mt-6"/>
                                <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                                
                                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row my-5">
                                    <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">{{$t('GO_BACK_TO_LOGIN')}}</vs-button>
                                    <vs-button :disabled="!validateForm"  @click="resetPassword" class="w-full sm:w-auto">{{$t('RESET')}}</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: '',
            email: ''
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.id != '' && this.email != '';
        },
    },
    methods: {
        resetPassword() {
            // Loading
            this.$vs.loading()

            this.$http.put(`/api/admin-management/admins/reset-password`,{ id: this.id, email: this.email })
                .then((response) => {

                    this.$vs.loading.close()
                    
                    if(response.data.resultCode !== 200){
                        this.errorAlert(this.$t("FAIL"), this.$t(response.data.resultMessage))
                    } else {
                        this.successAlert(this.$t("SUCCESS"), this.$t("SUCCESS_PASSWORD_RESET"))
                    } 

                })
                .catch((error) => {
                    this.$vs.loading.close()
                    this.errorAlert(this.$t("ERROR"), error.message)
                })
        },
  }
}
</script>
